import type { FC } from "react";

import { TableCell } from "@/components/ui/table";
import { cn } from "@/lib/utils";

import type { TableProps } from "./types";

const TableCellText: FC<TableProps> = ({
  children,
  classes,
  last = false,
  rowSpan = 1,
  colSpan = 1,
}) => {
  return (
    <TableCell
      className={cn(
        "px-4 py-[16px] text-xs",
        last && "border-b border-gray-200",
        classes
      )}
      rowSpan={rowSpan}
      colSpan={colSpan}
    >
      {children}
    </TableCell>
  );
};

export default TableCellText;
